<template>
  <div>
    <i class="iconfont iconfanhui hamburger" :class="{'is-active':isActive}" @click="toggleClick"></i>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}
</script>

<style scoped>
.hamburger {
  display: inline-block;
  cursor: pointer;
  transform: rotate(180deg);
  transition: .38s;
  transform-origin: 50% 50%;
  font-size: 22px;
  color: #5143EB;
}

.hamburger.is-active {
  transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Hamburger/index.vue